import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate, useI18n, withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/local-signer-share/local-signer-share.yml';

import { ControlPageBody } from '../../../ControlPageBody';

/**
 * `v4` arm step 1: the current (control) share screen, with a Continue affordance added so the signer
 * can advance to the new local-signer goal screen. Reuses `ControlPageBody` verbatim so the arm tests
 * the real current share experience; only the Continue footer is new.
 */
type Props = Readonly<{ onContinue: () => void }>;

const CurrentShareScreenComponent: React.FC<Props> = ({ onContinue }) => {
	const { translate } = useI18n();

	// No wrapping flex column: ControlPageBody carries its own `mx-auto max-w-[610px]` block, and auto
	// cross-axis margins stop stretching inside a flex parent (the card narrows and shifts left). Plain
	// block siblings keep the control body full-width, with the Continue below it.
	return (
		<>
			<ControlPageBody />
			<div className="px-4 py-4 text-center" data-qa="constituent-current-share-continue">
				<Button variant="tertiary" onClick={onContinue} aria-label={translate('corgi.local_signer_share.continue')}>
					<span className="underline">
						<Translate value="corgi.local_signer_share.continue" />
					</span>
				</Button>
			</div>
		</>
	);
};

export const CurrentShareScreen = withI18nPlaceholders(I18N_PLACEHOLDERS, CurrentShareScreenComponent);
